import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b088cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "permission" }
const _hoisted_2 = {
  class: "permission-inner",
  "data-testid": "level-0-permissions"
}
const _hoisted_3 = {
  class: "permission-inner",
  "data-testid": "level-1-permissions"
}
const _hoisted_4 = {
  class: "permission-inner",
  "data-testid": "level-2-permissions"
}

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Props = {
  disabled?: boolean
  isLevel0Enabled?: boolean
  isLevel1Enabled?: boolean
  isLevel2Enabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Permissions',
  props: {
    disabled: { type: Boolean },
    isLevel0Enabled: { type: Boolean },
    isLevel1Enabled: { type: Boolean },
    isLevel2Enabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app", { disabled: _ctx.disabled }]),
    "data-testid": "details-link"
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    _renderSlot(_ctx.$slots, "text"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isLevel0Enabled)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              height: "13",
              width: "13",
              color: "var(--blue-75)",
              name: "permission-profiledata-auth"
            }))
          : (_openBlock(), _createBlock(SvgIcon, {
              key: 1,
              height: "13",
              width: "13",
              color: "var(--neutral-80)",
              name: "permission-profiledata-auth"
            }))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLevel1Enabled)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              height: "13",
              width: "13",
              color: "var(--yellow-75)",
              name: "permission-account"
            }))
          : (_openBlock(), _createBlock(SvgIcon, {
              key: 1,
              height: "13",
              width: "13",
              color: "var(--neutral-80)",
              name: "permission-account"
            }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLevel2Enabled)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              height: "13",
              width: "13",
              color: "var(--red-75)",
              name: "permission-admin"
            }))
          : (_openBlock(), _createBlock(SvgIcon, {
              key: 1,
              height: "13",
              width: "13",
              color: "var(--neutral-80)",
              name: "permission-admin"
            }))
      ])
    ])
  ], 2 /* CLASS */))
}
}

})